import React, { Component } from 'react';
import ReactDOMServer from 'react-dom/server';
import PropTypes from 'prop-types';


export default class Popover extends Component {

    componentDidMount() {
        $(this.popover).popover({
            html: this.props.html,
        });

        document.addEventListener('click', this.handleDocumentClick);
    }

    componentWillUnmount() {
        this.doCleanUp();
    }

    doCleanUp() {
        $(this.popover).popover('destroy');
        document.removeEventListener('click', this.handleDocumentClick);
    }

    handleDocumentClick = () => {
        if (this.popover && !this.popover.contains(event.target)) {
            $(this.popover).popover('hide');
        }
    }

    handleClick() {
		$(this.popover).popover('toggle');
    }
    
    render() {
        const Template = React.isValidElement(this.props.template) ? 
            ReactDOMServer.renderToString(
                this.props.template
            ) : null;

        const ContentTemplate = React.isValidElement(this.props.content) ?
            ReactDOMServer.renderToString(
                this.props.content
            ) : this.props.content;

        return(
            <span 
                className={this.props.className}
                onClick={() => this.handleClick()}
                data-toggle="popover"
                data-trigger="focus"
                data-title={this.props.title}
                data-content={ContentTemplate}
                data-template={Template}
                data-placement={this.props.placement}
                ref={node => this.popover = node}
            >
                {this.props.triggerComponent}
            </span>
        );
    }
}

Popover.defaultProps = {
    onClick: f => f,
    placement: 'right',
    html: false,
};

Popover.propTypes = {
    /**
     * OnClick callback
     */
    onClick: PropTypes.func,

    /**
     * Position
     */
    placement: PropTypes.oneOf([
        'auto', 'left', 'right', 'top', 'bottom'
    ]),

    /**
     * Popover title
     */
    title: PropTypes.string,

    /**
     * Popover content wrapped inside div.class="popover"
     */
    content: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.element,
    ]),

    /**
     * Inject content as HTML template
     */
    html: PropTypes.bool,
};


// WEBPACK FOOTER //
// ./src/modules/app/components/popover.js